import localeNL from './locales/nl'
import localeEN from './locales/en'
import localeFR from './locales/fr'
import localeDE from './locales/de'

export default {
  nl: localeNL,
  en: localeEN,
  fr: localeFR,
  de: localeDE
}



// WEBPACK FOOTER //
// ./src/localization/locales.js